@for (d of days; track d.key) {
<div class="row align-items-center py-2 underline">
  <div class="col">{{ d.label }}</div>
  <div class="col">
    <mat-slide-toggle
      [checked]="operatingHours[d.key].enabled"
      (change)="onToggleEnabled(d.key, $event.checked)"
    ></mat-slide-toggle>
  </div>

  <div class="col d-flex align-items-center gap-2">
    <app-timepicker
      [disabled]="!operatingHours[d.key].enabled"
      [label]="'Open'"
      [value]="operatingHours[d.key].open ?? null"
      (valueChange)="onChangeOpen(d.key, $event)"
    />

    <app-timepicker
      [disabled]="!operatingHours[d.key].enabled"
      [label]="'Close'"
      [value]="operatingHours[d.key].close ?? null"
      (valueChange)="onChangeClose(d.key, $event)"
    />
  </div>
</div>
}
